<template>
    <div class="reunioes-projeto">
        <div class="cabecalho-aba">
            <h3>Reuniões do projeto</h3>
            <button
                v-if="!somenteLeitura"
                type="button"
                class="btn btn-primary"
                @click="abrirAgendar"
            >
                <i class="bi bi-calendar-plus"></i>
                Agendar reunião
            </button>
        </div>

        <div v-if="loading" class="loading"><div></div></div>

        <template v-else>
            <div v-if="needConnectGoogle" class="conectar-google">
                <p>Para agendar reuniões neste projeto, conecte sua conta Google Agenda.</p>
                <button type="button" class="btn btn-primary" :disabled="conectandoGoogle" @click="conectarGoogle(false)">
                    {{ conectandoGoogle ? 'Abrindo Google…' : 'Conectar conta Google' }}
                </button>
                <button type="button" class="btn btn-secondary" @click="needConnectGoogle = false">Cancelar</button>
            </div>

            <div v-if="erro" class="erro">
                <p>{{ erro }}</p>
                <button type="button" class="btn btn-secondary" @click="carregar">Tentar novamente</button>
            </div>

            <p v-if="mensagemSucesso" class="mensagem-sucesso">{{ mensagemSucesso }}</p>

            <ul v-if="!erro && reunioes.length" class="lista-reunioes">
                <li
                    v-for="r in reunioes"
                    :key="r.id"
                    class="item-reuniao"
                    :class="{ 'status-cancelado': r.status === 'cancelled' }"
                >
                    <div class="reuniao-cabecalho">
                        <div class="reuniao-titulo">{{ r.summary || '(Sem título)' }}</div>
                        <div class="reuniao-acoes">
                            <a v-if="r.hangoutLink" :href="r.hangoutLink" target="_blank" class="chip bg-ok">Abrir no Meet</a>
                            <a v-if="r.htmlLink" :href="r.htmlLink" target="_blank" class="chip bg-cinza">Ver na Agenda</a>
                            <button
                                v-if="!somenteLeitura"
                                type="button"
                                class="chip bg-erro btn-excluir"
                                :disabled="excluindoId === r.id"
                                @click="excluirReuniao(r)"
                            >
                                {{ excluindoId === r.id ? 'Excluindo…' : 'Excluir' }}
                            </button>
                        </div>
                    </div>

                    <div class="reuniao-horario">
                        <i class="bi-clock-fill"></i>
                        {{ textoHorario(r) }}
                    </div>
                    <div v-if="r.location" class="reuniao-info">
                        <i :class="r.location === 'Online' ? 'bi bi-camera-video-fill' : 'bi bi-geo-alt-fill'"></i>
                        {{ r.location }}
                    </div>
                    <div v-if="r.description" class="reuniao-descricao" v-html="descricaoComoHtml(r.description)"></div>

                    <div v-if="participantesLista(r).length" class="reuniao-participantes">
                        <div class="participantes-titulo">Participantes</div>
                        <div class="participantes-lista">
                            <div
                                v-for="(p, i) in participantesLista(r)"
                                :key="p.email || i"
                                class="participante"
                                :class="{ organizador: p.organizer }"
                            >
                                <span class="nome">{{ p.displayName || p.email }}</span>
                                <span v-if="p.organizer" class="chip bg-sucesso">Organizador(a)</span>
                            </div>
                        </div>
                    </div>

                    <div class="reuniao-tarefas">
                        <div class="participantes-titulo">Tarefas desta reunião</div>
                        <table class="tabela tabela-tarefas-reuniao">
                            <tbody>
                                <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th>Responsável</th>
                                    <th>Início prev.</th>
                                    <th>Fim prev.</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                                <tr v-for="t in (r.tarefas || [])" :key="t.id" class="linha-tarefa">
                                    <td class="clicavel" @click="abrirModalTarefa(r, t)">
                                        <span class="codigo-tarefa">{{ t.codigo || '–' }}</span>
                                    </td>
                                    <td
                                        class="descricao-tarefa clicavel"
                                        :title="t.descricao || t.titulo"
                                        @click="abrirModalTarefa(r, t)"
                                    >
                                        <div class="descTarefa">{{ t.descricao || t.titulo || '–' }}</div>
                                    </td>
                                    <td class="clicavel" @click="abrirModalTarefa(r, t)">
                                        {{ t.responsavel?.name || '–' }}
                                    </td>
                                    <td>
                                        <input
                                            type="date"
                                            :value="t.dt_inicio || ''"
                                            :disabled="somenteLeitura"
                                            @change="atualizarDataTarefa(r, t.id, 'dt_inicio', $event.target.value)"
                                        >
                                    </td>
                                    <td>
                                        <input
                                            type="date"
                                            :value="t.dt_fim || ''"
                                            :disabled="somenteLeitura"
                                            @change="atualizarDataTarefa(r, t.id, 'dt_fim', $event.target.value)"
                                        >
                                    </td>
                                    <td>
                                        <BarraProgresso
                                            :prop-item="getItemBarra(t)"
                                            :id-usuario="idUsuario"
                                            :is-coordenador="!somenteLeitura"
                                            @editarStatus="(id, payload) => atualizarStatusTarefa(r, id, payload)"
                                        />
                                    </td>
                                    <td></td>
                                </tr>
                                <tr v-if="!somenteLeitura">
                                    <td colspan="6">
                                        <div class="alinha-v inputNovaTarefa">
                                            <strong>{{ proximoCodigoTarefa(r) }}</strong>
                                            <input
                                                v-model="getNovo(r).descricao"
                                                type="text"
                                                placeholder="Descrição da nova tarefa"
                                                @keydown.enter.prevent="adicionarTarefa(r)"
                                            >
                                            <select v-model.number="getNovo(r).responsavel_id">
                                                <option value="" hidden>Responsável pela tarefa</option>
                                                <optgroup
                                                    v-if="(r.participantes_thalamus || []).length"
                                                    label="Participantes da reunião"
                                                >
                                                    <option
                                                        v-for="pt in (r.participantes_thalamus || [])"
                                                        :key="pt.user_id"
                                                        :value="pt.user_id"
                                                    >
                                                        {{ pt.name || pt.email }}
                                                    </option>
                                                </optgroup>
                                                <optgroup label="Outros">
                                                    <option
                                                        v-for="u in outrosResponsaveis(r)"
                                                        :key="u.id"
                                                        :value="u.id"
                                                    >
                                                        {{ u.name || u.email }}
                                                    </option>
                                                </optgroup>
                                            </select>
                                            <input type="date" v-model="getNovo(r).dt_fim" title="Fim previsto">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-primary"
                                                :disabled="!getNovo(r).descricao || !getNovo(r).responsavel_id || !getNovo(r).dt_fim"
                                                @click="adicionarTarefa(r)"
                                            >
                                                Adicionar
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </li>
            </ul>
            <p v-else-if="!erro" class="sem-reunioes">Nenhuma reunião vinculada a este projeto.</p>
        </template>

        <ModalAgendarReuniaoProjeto
            v-if="mostrarModalAgendar"
            :projeto-id="projeto.id"
            :projeto-nome="projeto?.nome"
            :projeto-codigo="projeto?.pcm_codigo || projeto?.codigo"
            :salvando="agendando"
            :erro-externo="erroAgendamento"
            @fechar="fecharAgendar"
            @confirmar="agendarReuniao"
            @conectar-google="conectarGoogle(true)"
        />

        <ModalEditarTarefaReuniao
            v-if="showModalTarefa && tarefaEditada && reuniaoDaTarefa"
            :prop-tarefa="tarefaEditada"
            :prop-reuniao-id="reuniaoDaTarefa.id"
            :usuarios="usuariosParaModal"
            :id-usuario="idUsuario"
            @fecharModal="fecharModalTarefa"
        />
    </div>
</template>

<script>
import { sso } from 'roboflex-thalamus-sso-lib'
import BarraProgresso from '@/components/BarraProgresso.vue'
import ModalEditarTarefaReuniao from '@/components/Modais/reunioes/ModalEditarTarefaReuniao.vue'
import ModalAgendarReuniaoProjeto from '@/components/Modais/reunioes/ModalAgendarReuniaoProjeto.vue'
import serviceReunioesProjeto from '@/services/serviceReunioesProjeto'

export default {
    name: 'ReunioesProjetoTab',
    components: { BarraProgresso, ModalEditarTarefaReuniao, ModalAgendarReuniaoProjeto },
    props: {
        projeto: { type: Object, required: true },
        somenteLeitura: { type: Boolean, default: false },
    },
    data() {
        return {
            reunioes: [],
            usuarios: [],
            loading: true,
            erro: null,
            needConnectGoogle: false,
            mensagemSucesso: null,
            mostrarModalAgendar: false,
            agendando: false,
            conectandoGoogle: false,
            erroAgendamento: null,
            excluindoId: null,
            novoPorReuniao: {},
            idUsuario: null,
            showModalTarefa: false,
            tarefaEditada: null,
            reuniaoDaTarefa: null,
        }
    },
    computed: {
        usuariosParaModal() {
            if (!this.reuniaoDaTarefa) return this.usuarios
            const participantes = (this.reuniaoDaTarefa.participantes_thalamus || []).map((p) => ({
                id: p.user_id,
                name: p.name,
                email: p.email,
            }))
            const ids = new Set(participantes.map((p) => p.id))
            const outros = this.usuarios.filter((u) => !ids.has(u.id))
            return [...participantes, ...outros]
        },
    },
    created() {
        this.idUsuario = sso.getUsuarioLogado()?.id ?? null
    },
    async mounted() {
        const retornoGoogle = this.tratarRetornoGoogle()
        await Promise.all([this.carregar(), this.carregarUsuarios()])
        if (retornoGoogle?.sucesso) {
            this.mensagemSucesso = retornoGoogle.sucesso
            setTimeout(() => { this.mensagemSucesso = null }, 6000)
        }
        if (retornoGoogle?.erro) {
            this.erro = retornoGoogle.erro
        }
    },
    watch: {
        'projeto.id'(val, old) {
            if (val && val !== old) this.carregar()
        },
    },
    methods: {
        async carregar() {
            if (!this.projeto?.id || this.projeto.id === 'criar') {
                this.reunioes = []
                this.loading = false
                return
            }
            this.loading = true
            this.erro = null
            try {
                const data = await serviceReunioesProjeto.listar(this.projeto.id)
                this.reunioes = data.events || []
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao carregar reuniões do projeto.'
            } finally {
                this.loading = false
            }
        },
        async carregarUsuarios() {
            try {
                this.usuarios = await serviceReunioesProjeto.listarUsuarios()
            } catch (_) {
                this.usuarios = []
            }
        },
        abrirAgendar() {
            this.needConnectGoogle = false
            this.erroAgendamento = null
            this.mostrarModalAgendar = true
        },
        fecharAgendar() {
            this.mostrarModalAgendar = false
            this.erroAgendamento = null
        },
        tratarRetornoGoogle() {
            const google = this.$route?.query?.google
            if (!google) return null

            const query = { ...this.$route.query }
            delete query.google
            this.$router.replace({ path: this.$route.path, query })

            if (google === 'connected') {
                return { sucesso: 'Permissões do Google atualizadas. Tente agendar a reunião novamente.' }
            }

            const codigo = String(google).startsWith('error=') ? String(google).slice('error='.length) : String(google)
            const mensagens = {
                save_failed: 'Não foi possível salvar a permissão do Google. Tente atualizar de novo.',
                sem_empresa: 'Seu usuário não está vinculado a uma empresa, então a conta Google não pode ser conectada.',
                exchange_failed: 'O Google não concluiu a autorização. Tente novamente.',
            }

            return { erro: mensagens[codigo] || 'Não foi possível atualizar a permissão do Google. Tente novamente.' }
        },
        rotaRetornoGoogle() {
            const caminho = this.$route?.path
            if (!caminho) return null

            const query = { ...(this.$route.query || {}), aba: '9' }
            delete query.google
            const busca = new URLSearchParams(query).toString()

            return `#${caminho}${busca ? `?${busca}` : ''}`
        },
        async conectarGoogle(exibirErroNoModal = false) {
            this.conectandoGoogle = true
            try {
                const data = await serviceReunioesProjeto.obterRedirectUrlGoogle(this.rotaRetornoGoogle())
                if (data?.redirect_url) {
                    window.location.href = data.redirect_url
                    return
                }
                throw new Error('URL de autorização não retornada pelo servidor.')
            } catch (e) {
                const mensagem = e.response?.data?.message || 'Não foi possível abrir a autorização do Google.'
                if (exibirErroNoModal) {
                    this.erroAgendamento = mensagem
                } else {
                    this.erro = mensagem
                }
            } finally {
                this.conectandoGoogle = false
            }
        },
        async agendarReuniao(payload) {
            this.agendando = true
            this.erro = null
            this.erroAgendamento = null
            try {
                await serviceReunioesProjeto.criar(this.projeto.id, payload)
                this.mostrarModalAgendar = false
                this.mensagemSucesso = 'Reunião agendada com sucesso.'
                setTimeout(() => { this.mensagemSucesso = null }, 4000)
                await this.carregar()
            } catch (e) {
                const code = e.response?.data?.code
                if (
                    e.response?.status === 403
                    && ['google_not_connected', 'google_reauthorization_required'].includes(code)
                ) {
                    this.erroAgendamento = e.response?.data?.message || 'Atualize as permissões da sua conta Google.'
                    await this.conectarGoogle(true)
                } else {
                    this.erroAgendamento = e.response?.data?.message || 'Erro ao agendar reunião.'
                }
            } finally {
                this.agendando = false
            }
        },
        async excluirReuniao(r) {
            if (!confirm(`Excluir a reunião "${r.summary || ''}"?`)) return
            this.excluindoId = r.id
            try {
                await serviceReunioesProjeto.excluir(this.projeto.id, r.id)
                this.reunioes = this.reunioes.filter((x) => x.id !== r.id)
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao excluir reunião.'
            } finally {
                this.excluindoId = null
            }
        },
        getNovo(r) {
            if (!this.novoPorReuniao[r.id]) {
                this.novoPorReuniao[r.id] = { descricao: '', responsavel_id: '', dt_fim: '' }
                this.novoPorReuniao = { ...this.novoPorReuniao }
            }
            return this.novoPorReuniao[r.id]
        },
        outrosResponsaveis(r) {
            const ids = new Set((r.participantes_thalamus || []).map((p) => p.user_id))
            return this.usuarios.filter((u) => !ids.has(u.id))
        },
        proximoCodigoTarefa(r) {
            return `Tarefa - ${(r.tarefas || []).length + 1}`
        },
        getItemBarra(t) {
            if (!t) return null
            return {
                id: t.id,
                status: t.status || 'Pendente',
                responsavel_id: t.responsavel_id,
            }
        },
        async atualizarStatusTarefa(r, tarefaId, payload) {
            if (this.somenteLeitura) return
            try {
                const data = await serviceReunioesProjeto.atualizarTarefa(r.id, tarefaId, { status: payload.status })
                const idx = (r.tarefas || []).findIndex((x) => x.id === tarefaId)
                if (idx !== -1 && data.tarefa) r.tarefas[idx] = data.tarefa
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao atualizar status.'
            }
        },
        async atualizarDataTarefa(r, tarefaId, campo, valor) {
            if (this.somenteLeitura) return
            try {
                const data = await serviceReunioesProjeto.atualizarTarefa(r.id, tarefaId, { [campo]: valor || null })
                const idx = (r.tarefas || []).findIndex((x) => x.id === tarefaId)
                if (idx !== -1 && data.tarefa) r.tarefas[idx] = data.tarefa
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao atualizar data.'
            }
        },
        async adicionarTarefa(r) {
            const novo = this.novoPorReuniao[r.id]
            if (!novo?.descricao || !novo.responsavel_id || !novo.dt_fim) return
            try {
                const data = await serviceReunioesProjeto.criarTarefa(r.id, {
                    descricao: novo.descricao,
                    responsavel_id: novo.responsavel_id,
                    dt_fim: novo.dt_fim,
                })
                if (!r.tarefas) r.tarefas = []
                r.tarefas.push(data.tarefa)
                this.novoPorReuniao[r.id] = { descricao: '', responsavel_id: '', dt_fim: '' }
                this.novoPorReuniao = { ...this.novoPorReuniao }
            } catch (e) {
                this.erro = e.response?.data?.message || 'Erro ao criar tarefa.'
            }
        },
        abrirModalTarefa(reuniao, tarefa) {
            if (this.somenteLeitura) return
            this.reuniaoDaTarefa = reuniao
            this.tarefaEditada = tarefa
            this.showModalTarefa = true
        },
        async fecharModalTarefa() {
            this.showModalTarefa = false
            this.reuniaoDaTarefa = null
            this.tarefaEditada = null
            await this.carregar()
        },
        textoHorario(r) {
            if (!r?.start) return '–'
            if (typeof r.start === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(r.start)) {
                return `${this.formatarData(r.start)}, Dia inteiro`
            }
            return `${this.formatarData(r.start)}, ${this.formatarHora(r.start)} – ${this.formatarHora(r.end)}`
        },
        formatarData(val) {
            const d = this.parseDate(val)
            if (!d) return '–'
            return d.toLocaleDateString('pt-BR')
        },
        formatarHora(val) {
            const d = this.parseDate(val)
            if (!d) return '–'
            return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
        },
        parseDate(val) {
            if (!val) return null
            const d = typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)
                ? new Date(`${val}T12:00:00`)
                : new Date(val)
            return Number.isNaN(d.getTime()) ? null : d
        },
        descricaoComoHtml(html) {
            if (!html || typeof html !== 'string') return ''
            const allowed = ['b', 'i', 'br', 'p', 'strong', 'em']
            const div = document.createElement('div')
            div.innerHTML = html
            Array.from(div.querySelectorAll('*'))
                .filter((el) => !allowed.includes(el.tagName.toLowerCase()))
                .forEach((el) => {
                    el.parentNode.replaceChild(document.createTextNode(el.textContent || ''), el)
                })
            return div.innerHTML
        },
        participantesLista(r) {
            const list = []
            const emails = new Set()
            if (r.organizer) {
                list.push({
                    email: r.organizer.email,
                    displayName: r.organizer.displayName,
                    organizer: true,
                })
                if (r.organizer.email) emails.add(r.organizer.email.toLowerCase())
            }
            const attendees = r.attendees || []
            attendees.forEach((att) => {
                if (att.resource) return
                const email = String(att.email || '')
                if (email.toLowerCase().includes('resource.calendar.google.com')) return
                const key = email.toLowerCase()
                if (key && emails.has(key)) return
                if (key) emails.add(key)
                list.push({
                    email: att.email,
                    displayName: att.displayName,
                    organizer: att.organizer,
                })
            })
            return list
        },
    },
}
</script>

<style scoped>
.cabecalho-aba {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
}

.cabecalho-aba h3 {
    margin: 0;
}

.conectar-google {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
    margin-bottom: 1rem;
    background: #fef3c7;
    border: 1px solid #f59e0b;
    border-radius: 8px;
    color: #92400e;
}

.conectar-google p {
    margin: 0;
    flex: 1 1 100%;
}

.mensagem-sucesso {
    color: green;
    margin-bottom: 1rem;
}

.lista-reunioes {
    list-style: none;
    padding: 0;
    margin: 0;
}

.item-reuniao {
    padding: 1rem;
    margin-bottom: 1rem;
    border: 1px solid var(--cor-separador, #e0e0e0);
    border-radius: 8px;
    background: var(--cor-bg, #fff);
}

.item-reuniao.status-cancelado {
    opacity: 0.7;
    background: var(--cor-cinza, #fafafa);
}

.reuniao-cabecalho {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.reuniao-titulo {
    font-weight: 600;
    font-size: 1.05rem;
}

.reuniao-acoes {
    display: flex;
    gap: 0.35rem;
    flex-wrap: wrap;
    align-items: center;
}

.btn-excluir {
    border: none;
    cursor: pointer;
    font: inherit;
}

.reuniao-horario,
.reuniao-info {
    font-size: 0.9rem;
    color: var(--cor-fonte-fraca, #555);
    margin: 0.35rem 0;
    display: flex;
    align-items: center;
    gap: 0.35rem;
}

.reuniao-descricao {
    font-size: 0.85rem;
    color: var(--cor-fonte-fraca, #666);
    margin: 0.5rem 0;
    line-height: 1.4;
}

.reuniao-participantes {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid var(--cor-separador, #eee);
}

.reuniao-tarefas {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
}

.participantes-titulo {
    font-size: 1rem;
    font-weight: 600;
    color: var(--cor-fonte-fraca, #666);
    margin-bottom: 0.4rem;
}

.participantes-lista {
    font-size: 0.9rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 16rem), 1fr));
    width: 100%;
    max-height: 12rem;
    overflow-y: auto;
    overflow-x: hidden;
}

.participante {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
    border-bottom: 1px solid var(--cor-separador);
    min-width: 0;
}

.participante .nome {
    font-weight: 500;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.descricao-tarefa {
    max-width: 14rem;
    width: 14rem;
    vertical-align: top;
}

.descTarefa {
    max-width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow-wrap: break-word;
}

.clicavel {
    cursor: pointer;
}

.codigo-tarefa {
    font-weight: 600;
    white-space: nowrap;
}

.inputNovaTarefa {
    gap: 0.5rem;
    flex-wrap: wrap;
}

.inputNovaTarefa strong {
    border: 1px solid var(--cor-separador);
    border-radius: 5px;
    width: fit-content;
    white-space: nowrap;
    padding: 0 0.5rem;
    text-align: center;
    align-content: center;
    height: 3rem;
}

.inputNovaTarefa select {
    width: fit-content;
}

.inputNovaTarefa input {
    height: 3rem;
    margin: 0;
    margin-left: 5px;
}

.inputNovaTarefa input[type="text"] {
    min-width: 12rem;
    flex: 1;
}

.inputNovaTarefa input[type="date"] {
    width: fit-content;
}

.sem-reunioes,
.erro {
    padding: 1rem 0;
}
</style>
